/**
 * attempt to parse placementInfo associated with the context on a note.
 */
function parseNotePlacementInfo(placementInfo, lockedContent) {
  if (!placementInfo) {
    return;
  }
  try {
    const parsedPlacementInfo = JSON.parse(placementInfo);
    if (isNotePlacementInfoV2(parsedPlacementInfo)) {
      return parsedPlacementInfo;
    }
    if (isNotePlacementInfoV1(parsedPlacementInfo)) {
      return {
        ...parsedPlacementInfo,
        renderedText: parsedPlacementInfo.renderedText ?? lockedContent,
        occurence: parsedPlacementInfo.occurence ? parsedPlacementInfo.occurence - 1 : 0
      };
    }
  } catch {
    // silently ignore errors while trying to parse placement info as a json
    // string
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isNotePlacementInfoV1(input) {
  return typeof input === "object" && input != null && typeof input.path === "string" && (!("occurence" in input) || typeof input.occurence === "number") && (!("renderedText" in input) || typeof input.renderedText === "string");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isNotePlacementInfoV2(input) {
  return typeof input === "object" && input != null && typeof input.path === "string" && Array.isArray(input.ranges) && input.ranges.length > 0;
}

export { parseNotePlacementInfo };
//# sourceMappingURL=parseNotePlacementInfo.js.map
